"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillIndicator = exports.PillIndicatorTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var PillIndicatorTypes;
(function (PillIndicatorTypes) {
    PillIndicatorTypes["RED"] = "red";
    PillIndicatorTypes["AMBER"] = "amber";
    PillIndicatorTypes["GREEN"] = "green";
    PillIndicatorTypes["GREY"] = "grey";
})(PillIndicatorTypes = exports.PillIndicatorTypes || (exports.PillIndicatorTypes = {}));
var PillIndicator = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("pill-indicator")
        .pmod(props.type || "grey")
        .pmod(props.size || "sm").bem;
    return (0, jsx_runtime_1.jsx)("div", __assign({}, props, { className: "".concat(cls, "  ").concat(props.className || "") }));
};
exports.PillIndicator = PillIndicator;
